"use client";

import { cn } from "@/lib/utils";
import { Loader2Icon } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import { useTranslations } from "next-intl";
import React from "react";
import { Button, ButtonProps } from "./button";

interface Props extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
}

export const LoadingButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, loading, loadingText, className, ...props }, ref) => {
    const t = useTranslations("Button");
    return (
      <Button {...props} ref={ref} className={cn(className, "overflow-hidden")}>
        <AnimatePresence mode="popLayout">
          {loading ? (
            <motion.div
              key="loading"
              transition={{ type: "spring", duration: 0.3, bounce: 0 }}
              initial={{ opacity: 0, y: -25 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 25 }}
              className="flex items-center gap-2 overflow-hidden"
            >
              <Loader2Icon className="h-4 animate-spin" />
              {loadingText || t("loading")}
            </motion.div>
          ) : (
            <motion.div
              key="content"
              transition={{ type: "spring", duration: 0.3, bounce: 0 }}
              initial={{ opacity: 1, y: 0 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 25 }}
              className="flex items-center gap-2 overflow-hidden"
            >
              {children}
            </motion.div>
          )}
        </AnimatePresence>
      </Button>
    );
  },
);

LoadingButton.displayName = "Button";

// export const TestLoadingButton = () => {
//   const loadingToggle = useToggle();

//   return (
//     <LoadingButton
//       isLoading={loadingToggle.value}
//       onClick={() => loadingToggle.toggle()}
//     >
//       Test Loading Button
//     </LoadingButton>
//   );
// };
